import React from 'react'


export default class Checkbox extends React.PureComponent {

    constructor(props) {
        super(props)
        this.state = {
            checked: props.checked,
        }
    }

    componentWillReceiveProps(props) {
        const checked = props.checked
        this.setState({checked})
    }

    _handleChange = () => {
        const checked = !this.state.checked
        this.setState({checked})
        if (this.props.id === undefined) {
            this.props.clickHandler(checked)
        } else {
            this.props.clickHandler(checked, this.props.id)
        }
    }

    render() {
        const {disabled, title} = this.props
        const {checked} = this.state
        return (
            <div className="React__checkbox">
                <div className="checkbox__checker">
                    <label>
                        <input
                            type="checkbox"
                            className="React__checkbox--input"
                            checked={checked}
                            disabled={disabled}
                            onChange={this._handleChange}
                        />
                        <span
                            className="React__checkbox--span"
                        />
                    </label>
                </div>
                <div className={checked ? "checkbox__title checked" : "checkbox__title"}>
                    <label>
                        <span
                            onClick={this._handleChange}
                        >
                            {title}
                        </span>
                    </label>
                </div>
            </div>
        )
    }
}
